import React, { FC } from "react";
import { CampaignPrice } from "../../../Model/CampaignPrice.csharp";
import { FeeWithDiscountTableLegacy } from "./FeeWithDiscountTableLegacy";
import { PriceListFeesSummary } from "../../Partials/PricingHighlight/PriceListFeesSummary.csharp";

interface PriceListFeesProps {
  priceListFees: PriceListFeesSummary;
  highlightPriceRowOnHover: boolean;
  campaignPrice: CampaignPrice | undefined;
}

export const PriceListFeesLegacy: FC<PriceListFeesProps> = ({
  priceListFees,
  highlightPriceRowOnHover,
  campaignPrice,
}) => {
  const shouldShowEveningWeekendPriceListFees =
    priceListFees.showEveningWeekendPrices &&
    priceListFees.fees.some(
      (fee) =>
        fee.regularPrice !== fee.eveningPrice ||
        fee.regularPrice !== fee.weekendPrice
    );
  const shouldShowBothEveningAndWeekendPriceListFees = priceListFees.fees.some(
    (fee) => fee.eveningPrice !== fee.weekendPrice
  );

  return priceListFees.fees.length > 0 ? (
    <>
      <FeeWithDiscountTableLegacy
        heading={priceListFees.priceListLabel}
        fees={priceListFees.fees}
        highlightPriceRowOnHover={highlightPriceRowOnHover}
        getPrice={(fee) => fee.regularPrice}
        getDiscount={(fee) => fee.regularDiscount}
      />
      {shouldShowEveningWeekendPriceListFees &&
        (shouldShowBothEveningAndWeekendPriceListFees ? (
          <>
            <FeeWithDiscountTableLegacy
              heading={
                !campaignPrice
                  ? priceListFees.eveningPriceListHeading
                  : priceListFees.eveningPriceListHeadingWithCampaign
              }
              fees={priceListFees.fees}
              highlightPriceRowOnHover={highlightPriceRowOnHover}
              getPrice={(fee) => fee.eveningPrice}
              getDiscount={(fee) => fee.eveningDiscount}
            />
            <FeeWithDiscountTableLegacy
              heading={
                !campaignPrice
                  ? priceListFees.weekendPriceListHeading
                  : priceListFees.weekendPriceLstHeadingWithCampaign
              }
              fees={priceListFees.fees}
              highlightPriceRowOnHover={highlightPriceRowOnHover}
              getPrice={(fee) => fee.weekendPrice}
              getDiscount={(fee) => fee.weekendDiscount}
            />
          </>
        ) : (
          <FeeWithDiscountTableLegacy
            heading={
              !campaignPrice
                ? priceListFees.eveningWeekendPriceListHeading
                : priceListFees.eveningWeekendPriceListHeadingWithCampaign
            }
            fees={priceListFees.fees}
            highlightPriceRowOnHover={highlightPriceRowOnHover}
            getPrice={(fee) => fee.weekendPrice}
            getDiscount={(fee) => fee.weekendDiscount}
          />
        ))}
    </>
  ) : null;
};
